export function isStorageBoxBulkSelectable(item, { readOnly, writable, inLockVault }) {
  if (!item?.itemId || readOnly || !writable) return false;
  if (item.canManage) return true;
  return Boolean(inLockVault && writable);
}

export function selectableItems(items, options) {
  return (items || []).filter((item) => isStorageBoxBulkSelectable(item, options));
}
